import "./error-block.css";
import { ErrorBlock } from './error-block';
export { createErrorBlock } from './create-error-block';
export default ErrorBlock;